// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mx-15[data-v-9a15a2c2]{margin-left:15px;margin-right:15px}.main-img[data-v-9a15a2c2]{max-width:500px;width:100%;max-height:400px;object-fit:contain;object-position:0}.attachment[data-v-9a15a2c2]{color:#edc731;background-color:#f0f2f5;width:fit-content;padding:5px;margin-bottom:10px;cursor:pointer;border-radius:3px}.attachment[data-v-9a15a2c2]:hover{color:#409eff}.attachment i[data-v-9a15a2c2]{color:#909399;padding-right:5px}", ""]);
// Exports
module.exports = exports;
